<docs>
## TkSkuChooser Docs

* 抽象到 YouUI
  * 友好数据结构 -> 通用数据结构 -> YuSkuChooser
</docs>

<template>
  <dl class="tk-sku_chooser" data-com="TkSkuChooser">
    <template v-for="oOpt in options">
      <dt class="tk-sku_chooser-label">{{ oOpt.name }}</dt>
      <dd class="tk-sku_chooser-key" v-for="(val, nIndex) in oOpt.values"><YuButton class="tk-sku_chooser-btn" :class="{
        'i-on': isChoose(oOpt.id, nIndex + 1),
        'i-can': canChoose(oOpt.id, nIndex + 1),
      }" type="text" @click="fnChoose(oOpt.id, nIndex + 1)">{{ val || '默认' }}</YuButton></dd>
    </template>
  </dl>
</template>

<script>
import YuButton from '../YouUI/Button/Button'

export default {
  componentName: 'TkSkuChooser',
  props: {
    sku: {
      type: Number,
      default: null
    },
    skus: {
      type: Array,
      default () {
        return []
      }
    },
    options: {
      type: Array,
      default () {
        return []
      }
    }
  },
  data () {
    return {
      nNowSku: this.sku || null,
      oSkuMap: {},  // [oSku.id]: [oSku]
      keys: [],
      oSkuMapKeys: {},  // [oSku.id]: [key1, key2, key3]
      cannotChooseList: [],  // [key1, key2]
      oIsChoose: {},  // {[oOpt.id]: [oOpt.position]}
      oCannotChooseMap: {}
    }
  },
  watch: {
    skus () {
      this.initSkuData()
    },
    options () {
      this.initKeys()
    },
    nNowSku (nVal) {
      this.fnChange(nVal)
    }
  },
  created () {
    this.initSkuData()
    this.initKeys()
    this.initSku()
  },
  methods: {
    initSkuData () {
      const _oSkuMap = this.oSkuMap
      const _oSkuMapKeys = this.oSkuMapKeys
      for (let oSku of this.skus) {
        _oSkuMap[oSku.id] = oSku
        const keys = []
        for (let oOpt of oSku.options) {
          keys.push(`${oOpt.option_id}.${oOpt.position}`)
        }
        _oSkuMapKeys[oSku.id] = keys
      }
    },
    initKeys () {
      const _keys = this.keys
      for (let oOpt of this.options) {
        (oOpt.values || []).forEach((val, index) => {
          _keys.push(`${oOpt.id}.${index + 1}`)
        })
      }
    },
    initSku () {
      const oSku = this.oSkuMap[this.nNowSku] || {}
      for (let oOpt of (oSku.options || [])) {
        this.fnChoose(oOpt.option_id, oOpt.position)
      }
    },
    isChoose (nOptID, nRank) {
      return this.oIsChoose[nOptID] === nRank
    },
    canChoose (nOptID, nRank) {
      return !this.cannotChooseList.includes(`${nOptID}.${nRank}`)
    },
    fnChoose (nOptID, nRank) {
      // 处理当前选择
      if (this.canChoose(nOptID, nRank)) {
        if (this.isChoose(nOptID, nRank)) {
          delete this.oIsChoose[nOptID]
        } else {
          this.oIsChoose[nOptID] = nRank
        }
      } else {
        // 赋值给新对象
        this.oIsChoose = {
          [nOptID]: nRank
        }
      }

      // 处理可选择
      const _oIsChoose = this.oIsChoose
      const keySet = new Set()
      for (let _nOptID in _oIsChoose) {
        const keys = this.getCannotChooseListByKey(_nOptID, _oIsChoose[_nOptID])
        for (let key of keys) {
          keySet.add(key)
        }
      }

      // 转换成数组
      this.cannotChooseList = [...keySet]
      this.setNowSku()
    },
    getCannotChooseListByKey (nOptID, nRank) {
      const nowKey = `${nOptID}.${nRank}`
      const _oCannotChooseMap = this.oCannotChooseMap
      let res = null
      if (nowKey in _oCannotChooseMap) {
        res = _oCannotChooseMap[nowKey] || []
      } else {
        const _oSkuMapKeys = this.oSkuMapKeys
        const canKeySet = new Set()

        // 遍历 SKU 对应的 Keys，记录相关包含的 Key
        for (let nSkuID in _oSkuMapKeys) {
          const keys = _oSkuMapKeys[nSkuID]
          if (keys.includes(nowKey)) {
            for (let key of keys) {
              canKeySet.add(key)
            }
          }
        }

        // 选出所有不包含的 Key
        const cannotKeySet = new Set()
        for (let key of this.keys) {
          if (!canKeySet.has(key)) {
            // 当前属性所有值都属于可选
            if (key.indexOf(nOptID) < 0) {
              cannotKeySet.add(key)
            }
            // else {
            //   canKeySet.add(key)
            // }
          }
        }

        // 记录并转换成数组返回
        res = (_oCannotChooseMap[nowKey] = [...cannotKeySet])
      }
      return res
    },
    setNowSku () {
      const _oIsChoose = this.oIsChoose
      if (Object.keys(_oIsChoose).length === this.options.length) {
        const _oSkuMapKeys = this.oSkuMapKeys
        const items = Object.entries(_oIsChoose)
        let nSku = null
        for (let sku in _oSkuMapKeys) {
          let keys = _oSkuMapKeys[sku]
          let nMark = 0
          for (let item of items) {
            if (keys.includes(item.join('.'))) {
              nMark += 1
            }
          }
          if (nMark === items.length) {
            nSku = parseInt(sku)
            break
          }
        }
        this.nNowSku = nSku
      } else {
        this.nNowSku = null
      }
    },
    fnChange (nSku) {
      if (this.sku !== nSku) {
        this.$emit('change', nSku)
      }
    }
  },
  components: {
    YuButton
  }
}
</script>

<style>
  .tk-sku_chooser {
    margin: 0;
    padding: 0;
  }
  .tk-sku_chooser-label {
    display: block;
    margin: 6px 0 10px;
    padding: 0;
  }
  .tk-sku_chooser-key {
    display: inline-block;
    margin: 0 10px 10px 0;
    padding: 0;
  }
  .tk-sku_chooser-btn {
    margin: 0;
    padding: 8px 12px;
    border: 0 solid currentColor;
    border-width: .5px;
    color: #777;
    opacity: .35;
  }
  .tk-sku_chooser-btn:active {
    opacity: 1;
  }
  .tk-sku_chooser-btn.i-can {
    opacity: 1;
  }
  .tk-sku_chooser-btn.i-on {
    color: #4685ee;
    opacity: 1;
  }
</style>



// WEBPACK FOOTER //
// Chooser.vue?c0547700